import { createSlice } from '@reduxjs/toolkit';
import * as constants from '../constants/index';
import apolloClient from '../queries';
import { FetchMember } from '../queries/index.graphql';

const { LAYOUT_TYPES } = constants;

export let sessionKey = undefined;

export const setSessionKey = (key) => sessionKey = key;

const initialState = {
  layoutType: LAYOUT_TYPES.default,
  currentStep: 1,
  errorMessages: [],
  // errorMessages: ['予期せぬエラーが発生しました。'],
  onCloseErrorModal: undefined,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setLayoutType: {
      reducer(state, action) {
        const { layoutType } = action.payload;

        state.layoutType = layoutType;
      },
      prepare(layoutType) {
        return { payload: { layoutType } };
      }
    },
    setCurrentStep: {
      reducer(state, action) {
        const { stepNumber } = action.payload;

        state.currentStep = stepNumber;
      },
      prepare(stepNumber) {
        return { payload: { stepNumber } };
      }
    },
    setErrorMessages: {
      reducer(state, action) {
        const { errorMessages } = action.payload;
        state.errorMessages = errorMessages;
      },
      prepare(errorMessages) {
        return { payload: { errorMessages } };
      }
    },
    addErrorMessage: {
      reducer(state, action) {
        const { errorMessage } = action.payload;
        state.errorMessages = [...state.errorMessages, errorMessage];
      },
      prepare(errorMessage) {
        return { payload: { errorMessage } };
      }
    },
    setOnCloseErrorModal: {
      reducer(state, action) {
        const { onClose } = action.payload;
        state.onCloseErrorModal = onClose;
      },
      prepare(onClose) {
        return { payload: { onClose } };
      }
    },
  },
});

export const {
  setLayoutType,
  setCurrentStep,
  setErrorMessages,
  addErrorMessage,
  setOnCloseErrorModal,
} = appSlice.actions;

export const handleLogin = async (loginId, password, onSuccess, onFailed) => {

  const { data, errors } = await apolloClient.query({
    query: FetchMember,
    variables: {
      input: { loginID: loginId, password },
    },
    errorPolicy: 'all',
    fetchPolicy: 'no-cache',
  });

  if (errors && errors.length) {
    onFailed && onFailed(errors);
    return;
  }

  onSuccess && onSuccess(data.member);
};

export default appSlice.reducer;
